module.exports = __webpack_public_path__ + "res/30-img_game_bg.a024aaa65ec910069a44490dc340ddbb.png";